import { InitPage } from "../index";
import { showToast } from "../../utils/toast";

declare let App: any;
declare let tenantCode: string;

class Mappings {
  private refreshFill: any;
  private refreshPct: any;

  constructor() {
    const _self = this;
    $("document").ready(function () {
      _self.subscribeChannel();
      // Define
      _self.refreshFill = $("#refreshFill");
      _self.refreshPct = $("#refreshPct");
      // Init
      _self.refreshFill.css("width", "0");
      _self.refreshPct.text("0%");
    });
  }

  subscribeChannel() {
    App.cable.subscriptions.create(
      {
        channel: "Item::MappingChannel",
        tenant_code: tenantCode,
      },
      {
        connected() {},
        disconnected() {},
        received: (data: any) => this.refreshReceivingData(data),
      },
    );
  }

  refreshReceivingData(data: any) {
    this.showProgress(data.progress);
    switch (data.status) {
      case "success":
        showToast(data.message || "Item mapping is refreshing...", "success");
        setTimeout(() => window.location.reload(), 3000);
        break;
      case "failure":
        showToast(data.message || "Failure", "error");
        $("#refreshProgress").removeClass("visible");
        break;
    }
  }

  showProgress(percentage: Int8Array) {
    $("#refreshProgress").addClass("visible");
    const progress = `${percentage}%`;
    this.refreshFill.css("width", progress);
    this.refreshPct.html(progress);
  }
}

export function LoadPage() {
  InitPage("mappings", () => new Mappings());
}
